export default __webpack_public_path__ + "e0fa95f04c9ef5e7fa073c11579f3e64.svg";